export default {
  normalTime(time) {
    const dateArr = time.split('T')
    const timeArr = dateArr[1].split('.')
    return dateArr[0] + ' ' + timeArr[0]
  }
}



// WEBPACK FOOTER //
// ./src/util/filters.js